module.exports = __webpack_public_path__ + "img/facility6.b0069a10.png";